// Global leave permissions
export const LEAVES_LIST_SEARCH = 'PEOPLE_MANAGEMENT_LEAVE_LIST_SEARCH',
  LEAVES_CREATE = 'PEOPLE_MANAGEMENT_LEAVE_CREATE',
  LEAVES_REQUEST = 'PEOPLE_MANAGEMENT_LEAVE_REQUEST',
  LEAVES_EXTEND = 'PEOPLE_MANAGEMENT_LEAVE_EXTEND',
  LEAVES_UPDATE = 'PEOPLE_MANAGEMENT_LEAVE_UPDATE';

// Entity leave permissions
export const LEAVE_UPDATE = 'UPDATE',
  LEAVE_EXTEND = 'EXTEND',
  LEAVE_GET = 'GET',
  LEAVE_CANCEL = 'CANCEL',
  LEAVE_READ_REQUEST_INFORMATION = 'READ_REQUEST_INFORMATION',
  LEAVE_READ_FULL_DATA = 'READ_FULL_LEAVE_DATA';

export const LEAVE_TYPES_ALIASES = {
  PAID_LEAVE: 'PAID_LEAVE',
  UNPAID_LEAVE: 'UNPAID_LEAVE',
  SICK_DAY: 'SICK_DAY',
  SICK_LEAVE: 'SICK_LEAVE',
  MILITARY_LEAVE: 'MILITARY_LEAVE',
  LEAVE_FOR_PERSONAL_CIRCUMSTANCES: 'LEAVE_FOR_PERSONAL_CIRCUMSTANCES',
  MATERNITY_LEAVE: 'MATERNITY_LEAVE',
} as const;

export const LEAVE_TYPES = {
  PAID_LEAVE: 'Paid leave',
  UNPAID_LEAVE: 'Unpaid leave',
  SICK_DAY: 'Sick day',
  SICK_LEAVE: 'Sick leave',
  MILITARY_LEAVE: 'Military leave',
  LEAVE_FOR_PERSONAL_CIRCUMSTANCES: 'Personal circumstances',
  MATERNITY_LEAVE: 'Maternity leave',
};

export const LEGACY_LEAVE_TYPE_LABELS = {
  COMPENSATION: 'Compensation',
} as const;

// Deprecated - to be removed after all leave types in the system will be updated
export const SICK_DAY_REASONS_TO_NEW_SUBTYPE = {
  I_AM_ILL: 'HEALTH_REASON_LEAVE',
  PLANNED_MEDICAL_PROCEDURE: 'MEDICAL_APPOINTMENT_LEAVE',
  CARE_FOR_RELATIVES: 'CARE_FOR_RELATIVE_LEAVE',
} as const;

export const SICK_DAY_SUB_TYPES = {
  HEALTH_REASON_LEAVE: 'Health reason',
  MEDICAL_APPOINTMENT_LEAVE: 'Medical appointment',
  CARE_FOR_RELATIVE_LEAVE: 'Care for relative',
} as const;

export const PAID_LEAVE_SUB_TYPES_ALIAS = {
  REGULAR_PAID_LEAVE: 'REGULAR_PAID_LEAVE',
  DAY_ON_DEMAND: 'DAY_ON_DEMAND',
  COMPENSATION: 'COMPENSATION',
} as const;

export const PAID_LEAVE_SUB_TYPES = {
  REGULAR_PAID_LEAVE: 'Regular',
  DAY_ON_DEMAND: 'Day on demand',
  COMPENSATION: 'Compensation',
} as const;

export const LEAVE_FOR_PERSONAL_CIRCUMSTANCES_SUB_TYPES = {
  CARE_FOR_HEALTHY_CHILD_LEAVE: 'Care for healthy child leave',
  SPECIAL_CIRCUMSTANCES_LEAVE: 'Special circumstances leave',
  TRAINING_LEAVE: 'Training leave',
  FORCE_MAJEURE_LEAVE: 'Force majeure leave',
  PRENATAL_MEDICAL_APPOINTMENTS_LEAVE: 'Prenatal medical appointments leave',
  BLOOD_DONATION_LEAVE: 'Blood donation leave',
  CARE_ALLOWANCE_LEAVE: 'Care allowance leave',
} as const;

export const MATERNITY_LEAVE_SUB_TYPES_ALIAS = {
  BY_MATERNITY_SICK_LEAVE: 'BY_MATERNITY_SICK_LEAVE',
  BY_PARENTAL_LEAVE: 'BY_PARENTAL_LEAVE',
  PL_MATERNITY_LEAVE: 'PL_MATERNITY_LEAVE',
  PL_PATERNITY_LEAVE: 'PL_PATERNITY_LEAVE',
  PL_PARENTAL_LEAVE: 'PL_PARENTAL_LEAVE',
  PL_CHILDCARE_LEAVE: 'PL_CHILDCARE_LEAVE',
} as const;

export const MATERNITY_LEAVE_SUB_TYPES = {
  BY_MATERNITY_SICK_LEAVE: 'Maternity sick leave',
  BY_PARENTAL_LEAVE: 'Parental leave',
  PL_MATERNITY_LEAVE: 'Maternity leave',
  PL_PATERNITY_LEAVE: 'Paternity leave',
  PL_PARENTAL_LEAVE: 'Parental leave',
  PL_CHILDCARE_LEAVE: 'Childcare leave',
} as const;

export const MATERNITY_LEAVE_SUB_TYPES_WITH_HINTS = {
  BY_MATERNITY_SICK_LEAVE: `Maternity sick leave / отпуск по беременности и родам`,
  BY_PARENTAL_LEAVE: 'Parental leave / отпуск по уходу за ребенком до 3-ех лет',
  PL_MATERNITY_LEAVE: 'Maternity leave / urlop macierzyński',
  PL_PATERNITY_LEAVE: 'Paternity leave / urlop ojcowski',
  PL_PARENTAL_LEAVE: 'Parental leave / urlop rodzicielski',
  PL_CHILDCARE_LEAVE: 'Childcare leave / urlop wychowawczy',
} as const;

export const LEAVE_PAYOUT_OPTIONS = {
  WITH_THE_SALARY: 'With the salary',
  BEFORE_PAID_LEAVE: 'Before paid leave',
};

export const LEAVE_STATUSES_ALIASES = {
  IN_APPROVAL: 'IN_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REGISTERED: 'REGISTERED',
};

export const LEAVE_STATUSES = {
  IN_APPROVAL: 'In approval',
  APPROVED: 'Approved, to be registered',
  REGISTERED: 'Registered',
  REJECTED: 'Rejected',
};

export const LEAVE_RULES_VIOLATION_REASON = {
  PERSONAL_MEDICAL_REASONS: 'Personal medical reasons',
  FAMILY_EMERGENCY: 'Family emergency',
  EDUCATION_OPPORTUNITY: 'Extraordinary educational opportunities',
  TRAVEL_OPPORTUNITY: 'Extraordinary travel opportunities',
  RELIGIOUS_REASONS: 'Religious reasons',
  MILITARY_DUTY: 'Military duty',
  COMPANY_ASKED_FOR_VACATION: 'Company asked for vacation',
};

export const IS_PHYSICAL_OPTION = {
  PHYSICAL: 'Yes',
  ELECTRONIC: 'No',
};

export const IS_PHYSICAL_OPTION_ALIASES = {
  PHYSICAL: 'PHYSICAL',
  ELECTRONIC: 'ELECTRONIC',
};

export const NON_STRICT_RULES = [
  'LEAVE-BR-7-BY',
  'LEAVE_BR_7-US',
  'LEAVE-BR-7-PL',
  'LEAVE-BR-8',
  'LEAVE-BR-9',
  'LEAVE-BR-10',
  'LEAVE-BR-10-PL-1',
  'LEAVE-BR-10-PL-2',
  'LEAVE-BR-11',
  'LEAVE-BR-15-1',
  'LEAVE-BR-15-2',
  'LEAVE-BR-17-PL',
  'LEAVE-BR-19',
];
